import React, { useState } from "react";
import dayjs from "dayjs";
import {
    CardTitle,
    CardContent,
    Callout,
    FileSelectButton,
    Card,
    Toast,
    DataTable,
    Column,
    Cell,
    Badge,
    Text,
    Button,
    ProgressBar,
    PopupYesNo,
    Popup,
    PopupContent,
    ButtonRow,
    Row,
    Col
} from "@tv2no/ui-react";
import { uploadTaxFile, deleteTaxFile } from "../../../../../api/services/taxYear";

export const Files = ({ taxYear, setSelectedFile, fetchTaxYear, busyImporting }) => {
    const [uploadProgress, setUploadProgress] = useState(null);
    const [busyDeletingFile, setBusyDeletingFile] = useState(false);
    const [taxFileToDelete, setTaxFileToDelete] = useState(null);

    const handleUploadFile = (file) => {
        uploadTaxFile(taxYear.year, file, (percent) => setUploadProgress(percent))
            .promise.then(() => {
                fetchTaxYear(() => {
                    Toast.success("Datagrunnlag ble lastet opp!");
                    setUploadProgress(null);
                });
            })
            .catch((error) => {
                Toast.error("Feil ved opplasting av datagrunnlag");
                console.error("Feil ved opplasting:", error);
                setUploadProgress(null);
            });
    };

    const handleDeleteFile = () => {
        const fileId = taxFileToDelete.id;
        setBusyDeletingFile(true);
        setTaxFileToDelete(null);
        deleteTaxFile(taxYear.year, fileId).then(() => {
            fetchTaxYear(() => {
                Toast.success("Filen ble slettet");
                setBusyDeletingFile(false);
            });
        });
    };

    return (
        <Card>
            <CardTitle title="Filer" />
            <CardContent>
                <Row>
                    <Col span={24}>
                        <Callout color="info">
                            Start med å laste opp filen her som inneholder all skattedata og leveres
                            av skatteetaten. Kommer det senere en oppdatert versjon laster du også
                            opp denne her. Har filen du laster opp samme navn som en tidligere
                            opplastet fil, vil denne overskrive den opprinnelige filen og
                            versjonsnummeret på den respektive filen blir inkrementert.
                        </Callout>
                    </Col>
                    <Col span={24}>
                        <FileSelectButton
                            accept="text/csv"
                            icon="upload"
                            color="primary"
                            onSelect={handleUploadFile}
                            disabled={uploadProgress != null}
                        >
                            Last opp nytt datagrunnlag
                        </FileSelectButton>
                    </Col>
                    <Col span={24}>
                        <DataTable
                            busy={busyDeletingFile}
                            rows={taxYear.files && Object.values(taxYear.files)}
                        >
                            <Column label="Navn" cell={({ row }) => <Cell>{row.name}</Cell>} />
                            <Column
                                label="Versjon"
                                cell={({ row }) => (
                                    <Cell>
                                        <Badge>ver {row.version}</Badge>
                                    </Cell>
                                )}
                            />
                            <Column
                                label="Størrelse"
                                cell={({ row }) => (
                                    <Cell>{Math.round(row.fileSize / 10 / 1024) / 100} MB</Cell>
                                )}
                            />
                            <Column
                                label="Opprettet"
                                cell={({ row }) => (
                                    <Cell>
                                        <Text color="base">{dayjs(row.created).format("L")}</Text>
                                    </Cell>
                                )}
                            />
                            <Column
                                cell={({ row }) => (
                                    <Cell align="right">
                                        <ButtonRow>
                                            <Button
                                                icon="trash"
                                                size="small"
                                                iconColor="error"
                                                square
                                                onClick={() => setTaxFileToDelete(row)}
                                            />
                                            <Button
                                                size="small"
                                                icon="arrow-down"
                                                iconColor="primary"
                                                onClick={() => setSelectedFile(row)}
                                                disabled={!!busyImporting}
                                            >
                                                Importer
                                            </Button>
                                        </ButtonRow>
                                    </Cell>
                                )}
                            />
                        </DataTable>
                    </Col>
                </Row>
            </CardContent>

            {/* File upload progress */}
            <Popup visible={!!uploadProgress}>
                <PopupContent>
                    <ProgressBar percent={uploadProgress}>Laster opp datagrunnlag...</ProgressBar>
                </PopupContent>
            </Popup>

            {/* POPUP: Delete tax file confirm */}
            {taxFileToDelete ? (
                <PopupYesNo
                    busy={busyDeletingFile}
                    title="Slette datagrunnlag?"
                    onYes={handleDeleteFile}
                    onNo={() => setTaxFileToDelete(null)}
                >
                    Er du sikker på at du vil permanent slette datagrunnlaget {taxFileToDelete.name}
                    ?
                </PopupYesNo>
            ) : null}
        </Card>
    );
};
